import { getBaseFeature } from '@/assets/style/variable'

const styObj = {
  default: {
    '--mb-page-bg': `url(${require('@/assets/packageAssets/views/P1_Girls/MyBeans/default/bg.webp')})`,
    '--mb-income-num-color': '#391d41',
    '--mb-income-label-color': '#999999',
    '--mb-today-income-color': '#a337fc',
    '--mb-withdrawal-bg': '#a338fc',
    '--mb-withdrawal-color': '#ffffff',
    '--mb-report-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/MyBeans/default/time.webp')})`,
  },

  kiko: {
    '--mb-page-bg': `url(${require('./images/bg-kiko.webp')})`,
    '--mb-income-num-color': '#333333',
    '--mb-income-label-color': '#b2b2b2',
    '--mb-today-income-color': '#b79b21',
    '--mb-withdrawal-bg': '#ffe242',
    '--mb-withdrawal-color': '#ffffff',
    '--mb-report-icon': `url(${require('./images/report-kiko.webp')})`,
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        if (styObj[this.packageName]) {
          return { ...getBaseFeature(), ...styObj[this.packageName] }
        }
        return { ...getBaseFeature(), ...styObj.default }
      }
      return { ...getBaseFeature() }
    },
  },
}
